import { MessageBar, MessageBarBody, MessageBarTitle, Text } from '@fluentui/react-components';

/**
 * Shown when the pane is loaded somewhere it cannot work: a plain browser tab during
 * development, or an Office host other than Outlook.
 */
export function HostUnsupported({ host }: { host: string | null }) {
  return (
    <div style={{ padding: 16, display: 'grid', gap: 8 }}>
      <MessageBar intent="warning">
        <MessageBarBody>
          <MessageBarTitle>Not running in Outlook</MessageBarTitle>
          This pane reads the open email, so it only works inside Outlook.
        </MessageBarBody>
      </MessageBar>
      <Text size={200}>
        {host == null
          ? 'No Office host detected. Sideload the add-in, or open a message and launch it from the ribbon.'
          : `Detected host: ${host}.`}
      </Text>
    </div>
  );
}
